/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Actual_Lamb_GleamInputs */

const fr_keen_actual_lamb_gleam = /** @type {(inputs: Keen_Actual_Lamb_GleamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hériter du rôle`)
};

/**

* @param {Keen_Actual_Lamb_GleamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const keen_actual_lamb_gleam = /** @type {((inputs?: Keen_Actual_Lamb_GleamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Actual_Lamb_GleamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_keen_actual_lamb_gleam(inputs)
});